import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
import store from '@/store'
import conf from '@/utils/config/index'
var rsaUtil = {
  // RSA 位数  1024，这里要跟后端对应
  bits: 512,
  // 当前JSEncrypted对象
  thisKeyPair: {},
}
export default {
  // 获取aeskey，
  genak(length = 12) {
    let random =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let str = ''
    for (let i = 0; i < length; i++) {
      str = str + random.charAt(Math.random() * random.length)
    }
    return str
  },

  // aes加密
  ae(plaintext, key) {
    // if (plaintext instanceof Object) {
    // // JSON.stringify
    //   plaintext = JSON.stringify(plaintext)
    // }
    let encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(plaintext),
      CryptoJS.enc.Utf8.parse(key),
      { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    )
    return encrypted.toString()
  },

  // aes 解密
  ad(ciphertext, key) {
    let decrypt = CryptoJS.AES.decrypt(
      ciphertext,
      CryptoJS.enc.Utf8.parse(key),
      { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    )
    let decString = CryptoJS.enc.Utf8.stringify(decrypt).toString()
    // if (decString.charAt(0) === '{' || decString.charAt(0) === '[') {
    // // JSON.parse
    //   decString = JSON.parse(decString)
    // }
    return decString
  },

  // 生成rsa密钥对(公钥和私钥)
  genrp(bits = rsaUtil.bits) {
    let genKeyPair = {}
    rsaUtil.thisKeyPair = new JSEncrypt({ default_key_size: bits })
    // 获取私钥
    genKeyPair.privateKey = rsaUtil.thisKeyPair.getPrivateKey()
    // 获取公钥
    genKeyPair.publicKey = rsaUtil.thisKeyPair.getPublicKey()
    return genKeyPair
  },
  // 公钥加密
  re(plaintext, publicKey) {
    // 由于没有genRsaKeyPair，所以需要执行下面这句
    rsaUtil.thisKeyPair = new JSEncrypt({ default_key_size: rsaUtil.bits })
    if (plaintext instanceof Object) {
      plaintext = JSON.stringify(plaintext)
    }

    publicKey && rsaUtil.thisKeyPair.setPublicKey(publicKey)
    return rsaUtil.thisKeyPair.encrypt(plaintext)
  },

  // 私钥解密
  rd(ciphertext, privateKey) {
    privateKey && rsaUtil.thisKeyPair.setPrivateKey(privateKey)
    let decString = rsaUtil.thisKeyPair.decrypt(ciphertext)
    // if (decString.charAt(0) === '{' || decString.charAt(0) === '[') {
    //   // JSON.parse
    //   decString = JSON.parse(decString)
    // }
    return decString
  },
  // 加密解密方法：string-需要解密的字段  code-约定的密钥    operation 默认false表示加密，传入true表示解密
  secret(string, code, operation) {
    if (string instanceof Object) {
      // JSON.stringify
      string = JSON.stringify(string)
    }
    code = CryptoJS.MD5(code).toString()
    var iv = CryptoJS.enc.Utf8.parse(code.substring(0, 16))
    var key = CryptoJS.enc.Utf8.parse(code.substring(16))
    if (operation) {
      return CryptoJS.AES.decrypt(string, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
      }).toString(CryptoJS.enc.Utf8)
    }
    return CryptoJS.AES.encrypt(string, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString()
  },
  getPng(str) {
    // 得到正确路径的图片
    return conf.cdnPic + '/fm2023/' + str + '.png'
  },
  getPng2022(str) {
    // 得到正确路径的图片
    return conf.cdnPic + '/fm2022/' + str + '.png'
  },
  checkNum(num) {
    return num == 1 ? 0 : 1
  },
  changeTheme(theme) {
    store.commit('setAttr', {
      name: 'theme',
      val: theme,
    })
  },
  getIcon(num) {
    if (num == 1) {
      return 'icon-gfans-wj'
    } else if (num == 2) {
      return 'icon-gfans-hj'
    } else {
      return 'icon-gfans-fj'
    }
  },
  // 飞猫云 2023文件类型图标
  fileIcon(ext) {
    let type = this.getFileExt(ext)
    switch (type) {
      case 'png':
        return this.getPng('fm_icon_photo')
      case 'zip':
        return this.getPng('fm_icon_zip')
      case 'doc':
        return this.getPng('fm_icon_word')
      case 'ppt':
        return this.getPng('fm_icon_ppt')
      case 'apk':
        return this.getPng('fm_icon_apk')
      case 'txt':
        return this.getPng('fm_icon_txt')
      case 'xls':
        return this.getPng('fm_icon_excelicon')
      case 'mp3':
        return this.getPng('fm_icon_music')
      case 'mp4':
        return this.getPng('fm_icon_video')
      case 'ipa':
        return this.getPng('fm_icon_mac')
      case 'exe':
        return this.getPng('fm_icon_exe')
      case 'common':
        return this.getPng('fm_icon_common')
      case 'folder':
        return this.getPng('fm_icon_files')
      case 'pdf':
        return this.getPng('fm_icon_pdf')
      case 'xmind':
        return this.getPng('fm_icon_xmind')
      case 'font':
        return this.getPng('fm_icon_font')
      case 'psd':
        return this.getPng('fm_icon_psd')
      case 'html':
        return this.getPng('fm_icon_html')
    }
  },
  // 飞猫盘、橘猫云格式检验
  getFileExt(ext) {
    if (
      this.in_array(ext, ['apk', 'mp3', 'exe', 'txt', 'xmind', 'psd', 'html'])
    ) {
      return ext
    } else if (
      this.in_array(ext, ['PNG', 'png', 'jpg', 'gif', 'bmp', 'jpeg'])
    ) {
      return 'png'
    } else if (this.in_array(ext, ['zip', 'rar'])) {
      return 'zip'
    } else if (
      this.in_array(ext, [
        'doc',
        'docx',
        'wps',
        'wpt',
        'dot',
        'dotx',
        'docm',
        'dotm',
        'rtf',
      ])
    ) {
      return 'doc'
    } else if (
      this.in_array(ext, [
        'ppt',
        'pptx',
        'pptm',
        'ppsx',
        'ppsm',
        'pps',
        'potx',
        'potm',
        'dpt',
        'dps',
      ])
    ) {
      return 'ppt'
    } else if (
      this.in_array(ext, [
        'xls',
        'xlt',
        'et',
        'xlsx',
        'xltx',
        'csv',
        'xlsm',
        'xltm',
      ])
    ) {
      return 'xls'
    } else if (this.in_array(ext, ['mov', 'mp4', 'MP4'])) {
      return 'mp4'
    } else if (this.in_array(ext, ['ipa', 'dmg'])) {
      return 'ipa'
    } else if (this.in_array(ext, ['folder'])) {
      return 'folder'
    } else if (this.in_array(ext, ['pdf'])) {
      return 'pdf'
    } else if (this.in_array(ext, ['font', 'otf', 'ttf', 'woff'])) {
      return 'font'
    } else {
      return 'common'
    }
  },
  in_array(search, arr) {
    for (var i = 0, len = arr.length; i < len; i++) {
      if (arr[i] === search) {
        return true
      }
    }
    return false
  },
    bytesToSize(bytes) {
    bytes = parseInt(bytes)
    if (!bytes || bytes === 0 || bytes === '0') return '0 B'
    var k = 1024
    var sizes = ['B', 'KB', 'MB', 'GB', 'T']
    var i = Math.floor(Math.log(bytes) / Math.log(k))
    return (bytes / Math.pow(k, i)).toFixed(2) + sizes[i]
  },
  setCookie(name, value, second) {
    var timestr = ''
    if (second > 0) {
      var exp = new Date()
      exp.setTime(exp.getTime() + 1000 * second)
      timestr = ';expires=' + exp.toGMTString()
    }
    document.cookie = name + '=' + escape(value) + timestr
  },
  getCookie(name) {
    var arrt = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    )
    if (arrt) {
      return unescape(arrt[2])
    } else {
      return localStorage.getItem('authtoken1') || null
    }
  },
  clearCookie(cname) {
    var cd = new Date()
    cd.setTime(cd.getTime() - 1)
    document.cookie = cname + '=-1;expires=' + cd.toUTCString()
    // window.document.cookie = cname + '=del;path=/;expires=-1'
  },
  Cookies(cname) {
    Cookies.remove(cname)
  },
  formatNumber(number) {
     const numValue = Number(number);
    if (numValue >= 10000) {
      const num = (Math.floor(numValue / 100) / 100).toFixed(2) // 先保留两位小数
      return num.replace(/\.?0+$/, '') + 'W' // 移除末尾的零和小数点
    }
    return numValue.toString();
  },
  // 极验
  initgt4(captchaId, callback) {
    initGeetest4(
      {
        captchaId: captchaId,
        product: 'bind',
        language: 'zho',
        riskType: 'slide',
        mask: {
          outside: false,
        },
        // rem: 0.8
      },
      function (captcha) {
        // captcha为验证码实例
        captcha
          .onReady(function () {})
          .onSuccess(function () {
            var validate = captcha.getValidate()
            if (validate) {
              callback(captcha, validate)
            }
          })
          .onError(function () {})
        captcha.onClose(function () {
          callback(captcha, 'close')
        })
        captcha.showCaptcha()
      }
    )
  },
    formatSeconds(value) {
    var secondTime = parseInt(value) > 0 ? parseInt(value) : 0
    var minuteTime = 0
    var hourTime = 0
    if (secondTime > 60) {
      minuteTime = parseInt(secondTime / 60)
      secondTime = parseInt(secondTime % 60)
      if (minuteTime > 60) {
        hourTime = parseInt(minuteTime / 60)
        minuteTime = parseInt(minuteTime % 60)
      }
    }
    var result = (secondTime < 10 ? '0' : '') + secondTime
    result =  (minuteTime > 0 ? (minuteTime < 10 ? '0' : '') + parseInt(minuteTime) + ':' : '00:') + result
    result = (hourTime > 0 ? (hourTime < 10 ? '0' : '') + parseInt(hourTime) + ':' : '00:') + result
    return result
  },
}
